import { getState } from "core-web/state";

const FREIGHT_PART_NO = process.env.REACT_APP_STORM_FREIGHT_NO;

class DataLayer {
    constructor() {
        this.intervalHandler = null;
        this.queue = [];
        this.gtmTrackingKey = process.env.REACT_APP_GTM_TRACKING_KEY;
        this.parametricsBlockList = [];
    }

    handler() {
        if (this.intervalHandler === null) {
            const self = this;
            this.intervalHandler = setInterval(() => {
                if (self.isLoaded()) {
                    clearInterval(self.intervalHandler);
                    self.processQueue();
                }
            }, 100);
        }
    }

    track(data = {}) {
        if (!this.isLoaded()) {
            this.queue.push(() => this.process(data));
            this.handler();
        } else {
            this.process(data);
        }
    }

    process(data) {
        window.dataLayer.push(data);
    }

    processQueue() {
        while (this.queue.length > 0) {
            this.queue.shift()();
        }
    }

    isLoaded() {
        return (
            window.google_tag_manager &&
            window.google_tag_manager[this.gtmTrackingKey] &&
            window.CookieInformationScriptLoaded
        );
    }

    reset() {
        if (!this.isLoaded()) {
            this.queue.push(() => {
                window.google_tag_manager[this.gtmTrackingKey].dataLayer.reset();
            });
            this.handler();
        } else {
            window.google_tag_manager[this.gtmTrackingKey].dataLayer.reset();
        }
    }

    getProducts(items) {
        const products = [];
        for (let i = 0; i < items.length; i++) {
            const exludePartNos = [FREIGHT_PART_NO];
            if (!exludePartNos.includes(items[i].part_no)) {
                products.push(this.getProduct(items[i], i));
            }
        }
        return products.filter((item) => item);
    }

    getProduct(product, position = null) {
        if (!product) {
            return;
        }

        const {
            part_no: partNo,
            name,
            parentProductName,
            price,
            price_list_id: priceListId,
            price_standard: priceStandard,
            price_original: priceOriginal,
            ean_code: eanCode,
            categories,
            category_id: categoryId,
            manufacturer,
            manufacturer_name: manufacturerName,
            quantity,
            format,
        } = product;

        const dataProduct = {
            name: parentProductName || name || "",
            id: partNo || "",
            ean: eanCode || "",
            price: price ? this.round(price) : 0,
            priceExVat: price || "",
            brand: manufacturer?.name || manufacturerName || "",
        };

        if (quantity) {
            dataProduct.quantity = quantity;
        }

        const defaultPriceListId = getState("application").defaultPriceList?.id;
        if (priceListId && defaultPriceListId && priceListId !== defaultPriceListId && priceStandard) {
            dataProduct.priceStandard = priceStandard;
        }

        dataProduct.priceStandard = dataProduct.priceStandard || priceOriginal;
        const itemDiscount = dataProduct.priceStandard ? dataProduct.priceStandard - price : priceOriginal - price;
        if (itemDiscount) {
            dataProduct.itemDiscount = Math.round(itemDiscount * 100) / 100;
        }

        if (categoryId) {
            let allCategories;
            if (Array.isArray(categories) && categories.length > 0) {
                allCategories = [].concat(categories);
                if (allCategories.length > 1 && allCategories[0].id === categoryId) {
                    allCategories.reverse();
                }
            }

            if (allCategories?.length) {
                const categoryString = allCategories.map((category) => category.value || category.name).join("/");
                dataProduct.category = categoryString;
                const [firstCategory, secondCategory, thirdCategory] = allCategories || [];
                dataProduct.firstCategory = firstCategory
                    ? firstCategory?.name || firstCategory?.value || firstCategory?.code || null
                    : null;
                dataProduct.secondCategory = secondCategory
                    ? secondCategory?.name || secondCategory?.value || secondCategory?.code || null
                    : null;
                dataProduct.thirdCategory = thirdCategory
                    ? thirdCategory?.name || thirdCategory?.value || thirdCategory?.code || null
                    : null;
            }
        }

        if (Array.isArray(format?.variant_parametrics) && format.variant_parametrics.length > 0) {
            const filteredParametrics = format.variant_parametrics.filter(({ code = "" }) => {
                return !this.parametricsBlockList.find((blockedParametric) => (code || "").includes(blockedParametric));
            });

            if (filteredParametrics.length > 0) {
                dataProduct.variant = filteredParametrics
                    .map((data) => data.value)
                    .filter((p) => p)
                    .join("|");
            }
        }

        if (product.list !== undefined) {
            dataProduct.list = product.list;
        }

        if (position !== null) {
            dataProduct.position = position + 1;
        }

        return dataProduct;
    }

    getImpressions(items) {
        const impressions = [];
        for (let i = 0; i < items.length; i++) {
            impressions.push(this.getImpression(items[i], i));
        }
        return impressions.filter((item) => item);
    }

    getImpression(product, position = null) {
        if (!product) {
            return;
        }

        const {
            categories,
            categoryPrimary,
            list,
            manufacturerName,
            manufacturer,
            name,
            objectID,
            pricing,
            priceExVat,
            partNo
        } = product;

        const dataProduct = {
            name: name || "",
            id: objectID || partNo || "",
            price: pricing?.pricelists?.web && this.round(pricing.pricelists.web.exVat) || priceExVat || undefined,
            brand: manufacturer?.name || manufacturerName || "",
        };

        if (categoryPrimary && Array.isArray(categories) && categories.length > 0) {
            dataProduct.category = (categories.find((c) => c.id === categoryPrimary) || {}).name || "";
        }

        // Variant
        // let variant = [];
        // if(variant.length > 0) {
        //     dataProduct.variant = variant.map(data => data).join('|')
        // }

        if (list) {
            dataProduct.list = list;
        }

        if (position !== null) {
            dataProduct.position = position + 1;
        }
        return dataProduct;
    }

    round(amount) {
        return parseFloat(amount, 10);
    }
}

const instance = new DataLayer();

export default instance;
